
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Compatibility: () => import("@/components/Compatibility.vue")
  }
})
export default class SuccessfulPostulation extends Vue {
  active_tab = 1;
  form = {
    checked: []
  };

  showModal() {
    (this as any).$refs["successful-postulation"].show();
  }

  hideModal() {
    (this as any).$refs["successful-postulation"].hide();
  }
}
